import ViolationsRemoveMc from './ViolationsRemoveMc';

export default ViolationsRemoveMc;
